<div class="theme-item" [style.background-color]="theme().layout_page.background_color">
  <div class="cover" [class.no-design]="!theme().cover.design">
    <app-cover-design [gallery]="gallery()" [theme]="theme()" [noAsset]="true"></app-cover-design>
    <div class="title" [appApplyTypographyStyles]="[theme().cover.title_typography]">Aa</div>
  </div>

  <div class="text">
    <div class="headings" [appApplyTypographyStyles]="[theme().section.title_typography]">
      @if (customTitle()) {
        {{ customTitle() }}
      } @else {
        Headings
      }
    </div>
    <div class="paragraph" [appApplyTypographyStyles]="[theme().section.paragraph_typography]">
      This is your paragraph.
    </div>
  </div>
</div>
